export default __webpack_public_path__ + "static/media/logo_with_name.763acbd4.svg";